// AUTO-GENERATED by generate-zod-schemas.ts — DO NOT EDIT
// Copyright 2026 Epic Digital Interactive Media LLC
// SPDX-License-Identifier: Apache-2.0

import { z } from 'zod'

export const codebaseSchema = z.object({
  id: z.string().max(100),
  orgId: z.string().max(100),
  workspaceId: z.string().max(100).optional(),
  userId: z.string().max(100).optional(),
  createdAt: z.string().max(200).datetime(),
  updatedAt: z.string().max(200).datetime(),
  metadata: z.record(z.string(), z.unknown()).optional(),
  extended: z.record(z.string(), z.unknown()).optional(),
  name: z.string().max(500),
  title: z.string().max(500),
  description: z.string().max(100000),
  repository: z.record(z.string(), z.unknown()),
  environment: z.record(z.string(), z.unknown()),
  deployment: z.record(z.string(), z.unknown()).optional(),
  agentWorkflow: z.record(z.string(), z.unknown()).optional(),
  tags: z.array(z.string()).optional(),
  status: z.string().max(50),
  archivedAt: z.string().max(200).datetime().optional(),
  archived: z.boolean(),
  tenantId: z.string().max(100).optional(),
  gitProvider: z.string().max(200).optional(),
  gitNamespace: z.string().max(200).optional(),
  gitRepo: z.string().max(200).optional(),
  gitRepoId: z.string().max(100).optional(),
  gitDefaultBranch: z.string().max(200).optional(),
  gitConnectionId: z.string().max(100).optional(),
  gitVisibility: z.string().max(200).optional(),
  gitPushedAt: z.string().max(200).optional(),
  gitWebUrl: z.string().max(200).optional(),
})

export type CodebaseInput = z.infer<typeof codebaseSchema>
